// Matomo analytics first
import './matomo.js';

// import * as polyfills from './polyfills';

import Alpine from 'alpinejs'

// gsap
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import TextAnimation from './gsap/TextAnimation';
import ContentIconAnimation from './gsap/ContentIconAnimation';
import ArrowsAnimation from './gsap/ArrowsAnimation';
import SpeedAnimation from './gsap/SpeedAnimation';
import {ClickPhoneScreen, PhoneAnimationDesktop} from './gsap/PhoneAnimation';

// components
import PlayVideoPreviews from './components/PlayVideoPreviews';
import Video from './components/Video';

gsap.registerPlugin(ScrollTrigger);

const MD_BREAKPOINT = 768;
const LG_BREAKPOINT = 992;

Alpine.data('PlayVideoPreviews', PlayVideoPreviews);
Alpine.data('Video', Video);

window.Alpine = Alpine
Alpine.start()

ClickPhoneScreen(gsap);
const initGSAP = () => {
  const initSmoothScrollAndGSAP = () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    // this.initSmoothScroll();

    const gsapMM = gsap.matchMedia();
    // gsapMM.add(`(max-width: ${LG_BREAKPOINT - 1}px)`, (context) => {
    //   const cleanupMethods = [];

    //   cleanupMethods.push(PhoneAnimationMobile(gsap, ScrollTrigger));

    //   return () => {
    //     cleanupMethods.forEach(fn => {
    //       if (typeof fn === 'function') {
    //         fn();
    //       }
    //     });
    //   };
    // });
    gsapMM.add(`(min-width: ${LG_BREAKPOINT}px)`, (context) => {
      const cleanupMethods = [];

      cleanupMethods.push(PhoneAnimationDesktop(gsap, ScrollTrigger));

      return () => {
        cleanupMethods.forEach(fn => {
          if (typeof fn === 'function') {
            fn();
          }
        });
      };
    });
    gsapMM.add(`(min-width: ${MD_BREAKPOINT}px)`, (context) => {
      const cleanupMethods = [];

      cleanupMethods.push(TextAnimation(gsap));
      cleanupMethods.push(ContentIconAnimation(gsap));
      cleanupMethods.push(ArrowsAnimation(gsap));
      cleanupMethods.push(SpeedAnimation(gsap));

      return () => {
        cleanupMethods.forEach(fn => {
          if (typeof fn === 'function') {
            fn();
          }
        });
      };
    });

    // run on mobiles as well
    // DividerAnimation(gsap);
  };

  initSmoothScrollAndGSAP();
};

initGSAP();
